var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeetCcRoad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 39,
    viewBox: "0 0 44 39",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.75 27.8571V39H44L33 0H24.75V8.35714H19.25V0H11L0 39H19.25V27.8571H24.75ZM19.25 13.9286H24.75V22.2857H19.25V13.9286Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeetCcRoad);
export default __webpack_public_path__ + "static/media/FeetCCRoad.1208b9c012beb55e1ca1bb4a65280280.svg";
export { ForwardRef as ReactComponent };